import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import ArrowButton from "../../components/Form/ArrowButton";
import { orderStatus } from "../../constants/commonConstants";
import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_MM_A } from "../../utils/dateFormating";

dayjs.extend(duration);

const CountdownTimer = ({
  deliveryDate,
  status,
  handleAcceptOrder,
  handleRequestRevision,
}) => {
  const navigate = useNavigate();
  const thread = useSelector((state) => state.thread);

  const [timeRemaining, setTimeRemaining] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  // Countdown time logic.
  const timeLeft = (deliveryDate) => {
    
    const now = new Date().getTime(); // Current time in milliseconds
    const deliveryTime = new Date(deliveryDate).getTime(); // Delivery time in milliseconds    
    const diff = deliveryTime - now;
    
    const absDiff = Math.abs(diff); // Work with absolute values for calculation

    const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((absDiff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((absDiff / (1000 * 60)) % 60);
    const seconds = Math.floor((absDiff / 1000) % 60);    

    return {
      days: days.toString().padStart(2, "0"),
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(timeLeft(deliveryDate));
    }, 1000); // Update every second

    return () => clearInterval(interval); // Clean up on component unmount
  }, [deliveryDate, status]);

  const renderButton = () => {
    switch (status) {
      case orderStatus.PENDING_PAYMENT:
        return (
          <ArrowButton
            text="Pay Now"
            onClick={() => {navigate(`/secure-payment/${thread?.selectedOrder?._id}`)}}
            width="242px"
            height="40px"
            iconDirection="right"
            iconPosition="after"
          />
        );
      case orderStatus.ORDER_DELIVERED:
        return (
          <div className="flex flex-col space-y-[12px]  items-start">
            <ArrowButton
              text="Accept Order"
              onClick={handleAcceptOrder}
              width="242px"
              height="40px"
              iconDirection="right"
              iconPosition="after"
            />
            <ArrowButton
              text="Request Revision"
              onClick={handleRequestRevision}
              width="242px"
              height="40px"
              iconDirection="right"
              iconPosition="after"
            />
          </div>
        );
      case orderStatus.IN_REVISION:
      case orderStatus.COMPLAINT_RAISED:
      case orderStatus.RESOLVED:
      case orderStatus.COMPLETED:
        return null;
      default:
        return null;
    }
  };

  return (//dayjs(formatYYYY_MM_DD(deliveryDate)).isBefore(dayjs())
    <div className="mt-[22px]">
      {status !== "Resolved" && status !== "Completed" && (
        <>
          <p className={twMerge("ml-[20px] font-roboto font-semibold text-[18px] leading-5 mb-4", dayjs(formatYYYY_MM_DD_HH_MM_A(deliveryDate)).isBefore(dayjs()) ? "text-red-500" : "text-primary" )}>
            {dayjs(formatYYYY_MM_DD_HH_MM_A(deliveryDate)).isBefore(dayjs()) ? "Overdue By" : "Time Left to Deliver"}
          </p>
          <div className="flex items-center ml-[20px]">
            {["Days", "Hours", "Minutes", "Seconds"].map((label, index) => {
              const value =
                label === "Days"
                  ? timeRemaining.days
                  : label === "Hours"
                  ? timeRemaining.hours
                  : label === "Minutes"
                  ? timeRemaining.minutes
                  : timeRemaining.seconds;

              return (
                <div key={label} className="flex items-center">
                  {/* Divider (before each time block, except the first one) */}
                  {index > 0 && (
                    <div className="h-6 w-[2px] bg-[#E6E7EC] mx-[14px] rounded-full"></div>
                  )}

                  {/* Time Block */}
                  <div className="flex flex-col items-center">
                    <span className={`text-level-4 font-medium leading-[12px] ${dayjs(formatYYYY_MM_DD_HH_MM_A(deliveryDate)).isBefore(dayjs()) ? "text-red-600" : "text-secondary"}`}>
                      {value}
                    </span>
                    <span className={`text-level-5 mt-2 font-medium leading-3 ${dayjs(formatYYYY_MM_DD_HH_MM_A(deliveryDate)).isBefore(dayjs()) ? "text-red-600" : "text-secondary"}`}>
                      {label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      <div className="mt-[24px] ml-[20px]">{renderButton()}</div>
      {status !== "Resolved" && status !== "Completed" && (
        <div className="w-full h-[1px] bg-[#E6E7EC] mt-[24px]"></div>
      )}
    </div>
  );
};

export default CountdownTimer;